export default __webpack_public_path__ + "static/media/snowuns-mobile-merch.2744ed29.png";